import { createRouter, createWebHashHistory } from 'vue-router'
// import Home from '../views/homeview/index.vue'
import Scenic from '../views/scenic/index.vue'
import News from '../views/news/index.vue'
import About from '../views/about/index.vue'
import LowCarbon from '../views/lowcarbon/index.vue'
import ParkService from '../views/parkservice/index.vue'

const routes = [

  {
    path: '/',
    redirect: '/home',
  }, {
    path: '/home',
    name: 'Home',
    component: () => import('../views/homeview/index.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/scenic/:tabId?',
    name: 'Scenic',
    component: Scenic,
    meta: { title: '著名景点' },
    children: [
      {
        path: 'detail/:id',
        name: 'ScenicDetail',
        component: () => import('../views/scenicdetail/index.vue'),
        meta: { title: '景点详情' }
      }
    ]
  },
  { path: '/news', name: 'News', component: News, meta: { title: '新闻动态' } },
  {
    path: '/lowcarbon',
    name: 'LowCarbon',
    component: LowCarbon,
    meta: { title: '低碳园林' },
    children: [
      {
        path: 'detail/:id',
        name: 'LowCarbonDetail',
        component: () => import('../views/scenicdetail/index.vue'),
        meta: { title: '低碳园林详情' }
      }
    ]
  },
  { path: '/about', name: 'About', component: About, meta: { title: '联系我们' } },
  { path: '/parkService', name: 'ParkService', component: ParkService, meta: { title: '游园服务' } },
  { path: '/newsDetail', name: 'NewsDetail', component: () => import('../views/newsdetail/index.vue'), meta: { title: '新闻动态' } },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  // 优先使用路由 meta 中的 title
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    // 可设置一个默认标题
    document.title = '奥森'
  }
  next()
})
export default router